import { render, staticRenderFns } from "./FollowerOrFollowingList.vue?vue&type=template&id=503c6c7f&scoped=true&"
import script from "./FollowerOrFollowingList.vue?vue&type=script&lang=js&"
export * from "./FollowerOrFollowingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503c6c7f",
  null
  
)

export default component.exports